import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rptloanledgerpopup',
  templateUrl: './rptloanledgerpopup.component.html',
  styleUrls: ['./rptloanledgerpopup.component.css']
})
export class RptloanledgerpopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
